import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

import AddContactOption from './add_contact';

// Copied to ./contact.js (minus the database rendering) rather than using a prop because we don't have
// control over props
const ContactAndDatabaseOption = (props) => {
  const { data, innerProps, innerRef, label } = props;

  if (data.type === 'addContact') return <AddContactOption {...props} />;

  if (data.type === 'addCompany') return <AddContactOption company {...props} />;

  const source = data.projectContact ? 'Project' : data.database;
  return (
    <div ref={innerRef} {...innerProps} className="entity">
      <FontAwesomeIcon
        className="type-icon"
        icon={data.type === 'Contacts::Person' ? faUser : faBriefcase}
        pull="left"
        size="lg"
      />

      <div>
        <div>
          <strong>{label}</strong>
        </div>
        <small>Source: {source}</small>
      </div>
    </div>
  );
};

ContactAndDatabaseOption.propTypes = {
  data: PropTypes.shape({
    database: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  label: PropTypes.string.isRequired
};

export default ContactAndDatabaseOption;
